// extracted by mini-css-extract-plugin
module.exports = {"inboxButton":"styles_inboxButton__9tDzS","unreadBadge":"styles_unreadBadge__3PbsP","modalContent":"styles_modalContent__2xgL6","modal":"styles_modal__3i-pP"};